export const TREND_DATA = [
  {
    title: 'financialAnalysis.EQUITY_TO_ASSETS',
    value: 'RT0248',
    color: '#006AA6',
    isBarChart: true,
  },
]
